import * as React from "react";
import { Payments as PaymentType } from "../../../../../store/PartnerPayments/Types";
import { formatDate } from "../../../../../utils/DateFormat";
import { NavLink } from "react-router-dom";
import { Currency } from "@vwpfs/mary-air-lib/components/air/05-atoms/CurrencyDisplay";
import { Alignment, ButtonsWrapper, Orientation } from "@vwpfs/mary-air-lib/components/air/06-molecules/ButtonsWrapper";
import { RowData, Table, TableData } from "@vwpfs/mary-air-lib/components/air/06-molecules/Table";
import { PageTabs } from "../../../../../store/AppDisplays";
import { CreditDebitIndicatorTypeDisplay } from "../../../../../store/Statements/Displays";
import { CreditDebitIndicator } from "../../../../../store/Statements/Types";
import { ThemeBreakpoints, ThemePalette, ThemeShadowSizes } from "@vwpfs/mary-air-lib/theme/_Types";
import { Button } from "@vwpfs/mary-air-lib/components/air/05-atoms/Button";
import { IconNames } from "@vwpfs/mary-air-lib/components/air/05-atoms/Icon";
/**
 *
 */
interface OwnProps {
    results: PaymentType;
    currentTab?: PageTabs;
    asAuditTab?: boolean;
}
/**
 *
 */
type Props = OwnProps;
/**
 *
 * @param props
 */
export class Results
    extends React.Component<Props, {}> {
    /**
     *
     * @param props
     */
    public constructor(props: Props) {
        super(props);
        this.getProcessedRows = this.getProcessedRows.bind(this);
        this.resultsData = this.resultsData.bind(this);
    }
    public render() {
        return (
            <React.Fragment>
                <Table
                    hasActions
                    data={{
                        columns: this.resultsData().columns,
                        rows: this.resultsData().rows,
                        sort: this.resultsData().sort,
                    }}
                />
            </React.Fragment>
        );
    }
    /**
     *
     */
    private getProcessedRows(): RowData[] {
        return this.props.results.content.map((row, index) => ({
            id: row.id,
            data: [
                row.paymentNumber || "",
                row.paymentDate ? (
                    <span key={`payment-date${index}`}>
                        {formatDate(new Date(row.paymentDate), "DD-MM-YYYY")}
                    </span>
                ) : "",
                row.invoiceNumber || "",
                row.invoiceDate ? (
                    <span key={`invoice-date${index}`}>
                        {formatDate(new Date(row.invoiceDate), "DD-MM-YYYY")}
                    </span>
                ) : "",
                row.bankAccount || "",
                row.statementLineId || "",
                row.mutationType === CreditDebitIndicator.DBIT
                    ? CreditDebitIndicatorTypeDisplay.DBIT : CreditDebitIndicatorTypeDisplay.CRDT,
                row.incasso ? "Incasso" : row.excasso ? "Excasso" : "",
                (
                    <h6 key={`${index}-h6`}>
                        {row.amount ? <Currency value={row.amount} /> : "n.a."}
                    </h6>
                ),
                <ButtonsWrapper
                    key={`navlink-${row.id}`}
                    asGroup
                    alignment={Alignment.RIGHT}
                    defaultOrientation={Orientation.HORIZONTAL}
                    orientations={{
                        [ThemeBreakpoints.XS]: Orientation.VERTICAL,
                        [ThemeBreakpoints.MD]: Orientation.HORIZONTAL,
                    }}
                >{
                        this.props.asAuditTab ? (
                                <NavLink to={`/audit/payments/${row.id}`}>
                                    <Button
                                        icon={IconNames.ARROW_RIGHT}
                                        theme={{
                                            palette: ThemePalette.CONTRAST_PRIMARY,
                                            shadow: ThemeShadowSizes.TINY,
                                        }}
                                    />
                                </NavLink>
                        ) : <></>}</ButtonsWrapper>,
            ],
        }));
    }
    /**
     *
     */
    private resultsData(): TableData {
        return {
            sort: undefined,
            columns: [
                {
                    label: "Payment number",
                },
                {
                    label: "Payment date",
                },
                {
                    label: "Invoice number",
                },
                {
                    label: "Invoice date",
                },
                {
                    label: "IBAN",
                },
                {
                    label: "Statement line Id",
                },
                {
                    label: "Mutation type",
                },
                {
                    label: "Incasso/Excasso",
                },
                {
                    label: "Amount",
                    alignRight: true,
                },
                this.props.asAuditTab ?
                    {
                        label: "Actions",
                    } : {
                        label: "",
                    },
            ],
            rows: this.getProcessedRows(),
        };
    }
}
